import { Fragment, useState } from 'react';

import _ from 'lodash';

import PropTypes from 'prop-types';

import Accordion from '@mui/material/Accordion';

import AccordionSummary from '@mui/material/AccordionSummary';

import AccordionDetails from '@mui/material/AccordionDetails';

import { FadeInAnimation } from '../../../components/shared';

const RoomTypeBuildingAmenities = (props) => {
    
    const { selectedBuilding, buildingContentCMS } = props;
    
    const buildingAmenities = _.get(selectedBuilding, 'amenities');
    const buildingAmenityIcons = _.get(buildingContentCMS, 'acf.icon');
    const defaultIconSrc = _.get(buildingContentCMS, 'acf.default_amenity_icon.url');

    const renderAmenities = (type) => {
        return _.map(buildingAmenities, (amenity, index) => {
            if (index < 4 && type !== 'accordion') {
                return (
                    <Fragment key={index}>
                        <FadeInAnimation>
                            <div className='building-amenities-amenity-container'>
                                {renderAmenityIcon(amenity)}
                                <span className='building-amenities-amenity-text'>{amenity}</span>
                            </div>
                            <hr className='building-amenities-hr' />
                        </FadeInAnimation>
                    </Fragment>
                );
            }
            if (index >= 4 && type === 'accordion') {
                return (
                    <Fragment key={index}>
                        <FadeInAnimation>
                            <div className='building-amenities-amenity-container'>
                                {renderAmenityIcon(amenity)}
                                <span className='building-amenities-amenity-text'>{amenity}</span>
                            </div>
                            <hr className='building-amenities-hr' />
                        </FadeInAnimation>
                    </Fragment>
                );
            }
            return null;
        });
    };

    const renderAmenityIcon = (amenityFromAPI) => {
        let returnDefault = true;
        let imgSrc = null;
        _.forEach(buildingAmenityIcons, (icon) => {
            const iconSrc = _.get(icon, 'icon_image.url');
            const amenityId = _.get(icon, 'amnenity_name');
            if (_.lowerCase(amenityId) === _.lowerCase(amenityFromAPI)) {
                returnDefault = false;
                imgSrc = iconSrc;
            }
        });
        if (returnDefault) {
            return <img src={defaultIconSrc} alt="homii-o" width={22} />;
        }
        return <img src={imgSrc} alt={amenityFromAPI} width={22} />;
    };

    const [expanded, setExpanded] = useState(false);
    const [text, setText] = useState('See More +');

    const handleAccordionChange = (value) => () => {
        setExpanded(!value);
        setText(value ? 'See More +' : 'See Less -');
    };

    return (
        <FadeInAnimation>
            <div id="building-amenities-section">
                <h3 className='building-amenities-header3'>Building Amenities</h3>
                <p className='building-amenities-details'>
                    Live the HOMii lifestyle, wherever and however you choose to.
                </p>
                {renderAmenities()}
                <div id="building-amenities-accordion" className='building-amenities-accordion-wrapper'>
                    <Accordion className='building-amenities-accordion' expanded={expanded} onChange={handleAccordionChange(expanded)}>
                        <AccordionSummary
                            aria-controls="panel1d-content"
                            id="building-ammenities-accordion-button"
                        >
                            <p className='building-amenities-accordion-button-text'>{text}</p>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className='building-amenities-container'>{renderAmenities('accordion')}</div>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </div>
        </FadeInAnimation>
    );
};

export default RoomTypeBuildingAmenities;

RoomTypeBuildingAmenities.propTypes = {
    selectedBuilding: PropTypes.object,
    buildingContentCMS: PropTypes.object,
};

